module.exports = __webpack_public_path__ + "img/tuijian.9a37fd29.png";